import { render, staticRenderFns } from "./text.vue?vue&type=template&id=3bc18aaf&"
import script from "./text.vue?vue&type=script&lang=js&"
export * from "./text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bc18aaf')) {
      api.createRecord('3bc18aaf', component.options)
    } else {
      api.reload('3bc18aaf', component.options)
    }
    module.hot.accept("./text.vue?vue&type=template&id=3bc18aaf&", function () {
      api.rerender('3bc18aaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/field-template/text.vue"
export default component.exports